// @flow

import get from 'lodash/get'

import { ChatBubbleMessage } from '@chatchamp/chatchamp-types'

export const LAST_MESSAGE_RECEIVED_COOKIE_NAME = 'trbo_ac-last-message-received'
// TODO; Thiago; 06.03.2024; Remove deprecated cookie in the future.
export const DEPRECATED_LAST_MESSAGE_RECEIVED_COOKIE_NAME = 'chatchamp-last-message-received'

export const isRequestInputMessage = (message: ChatBubbleMessage<any>): any => {
  return Boolean(
    message &&
    message.type === 'trigger' &&
    get(message, ['content', 'senderAction'], '') === 'request_input'
  )
}

export class ChatBubbleMessageClass<T> implements ChatBubbleMessage<T> {
  id: string
  type: string
  from: string
  to: string
  status: string
  content: T

  constructor (params: ?Object) {
    params && Object.assign(this, params)
  }
}
